import React from "react"
import Grid from "semantic-ui-react/dist/es/collections/Grid/Grid"
import Button from "semantic-ui-react/dist/es/elements/Button/Button"
import Header from "semantic-ui-react/dist/es/elements/Header/Header"
import Modal from "semantic-ui-react/dist/es/modules/Modal/Modal"
import "./StandardModal.css"

const StandardModal = ({ children, wide, ...rest }) => (
  <Modal
    {...rest}
    size="small"
    className={`StandardModal ${wide ? "StandardModal--wide" : ""}`}
  >
    {children}
  </Modal>
)

const ModalHeader = ({ header, subHeader }) => (
  <Modal.Header>
    <Header as="h1" style={{ margin: "0px", fontWeight: "400" }}>
      {header}
      {subHeader && (
        <Header.Subheader style={{ marginTop: ".7em" }}>
          {subHeader}
        </Header.Subheader>
      )}
    </Header>
  </Modal.Header>
)

const ModalContent = ({ children }) => <Modal.Content>{children}</Modal.Content>

const ModalActions = ({
  submitLabel,
  cancelLabel,
  onSubmit,
  onCancel,
  loading,
  cancelCanDisabled = true,
  submitDataAttr = {} // Temporary
}) => (
  <Modal.Actions>
    <Grid>
      <Grid.Row columns="2">
        <Grid.Column>
          <Button
            disabled={cancelCanDisabled && loading}
            onClick={onCancel}
            fluid
            content={cancelLabel ? cancelLabel : "Cancel"}
            basic
            primary
            type="button"
            data-testid="cancel"
          />
        </Grid.Column>
        <Grid.Column>
          <Button
            disabled={loading}
            onClick={onSubmit}
            fluid
            content={submitLabel ? submitLabel : "Continue"}
            primary
            type="button"
            data-testid="submit"
            {...submitDataAttr}
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </Modal.Actions>
)

StandardModal.Header = ModalHeader
StandardModal.Actions = ModalActions
StandardModal.Content = ModalContent

export default StandardModal
